import * as React from 'react';
import React__default from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var TYPE_IDENTIFIER$2 = 'input/children';
var type$3 = function (settings) {
    if (settings === void 0) { settings = {}; }
    return __assign(__assign({ append: true }, (settings || {})), { type: TYPE_IDENTIFIER$2 });
};

var type$2 = function (settings) {
    return __assign({ isomorphic: false, children: false }, settings);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = ".Input-module_input__WjT81{background:none;border:1px solid;border-radius:.25rem;color:inherit;padding:1rem}.Input-module_label__-OEBL{display:flex;flex-direction:column}.Input-module_label__-OEBL>*+*{display:block;margin-top:.25rem}.Input-module_labelText__Bvv-T{display:block}";
var inputStyles = {"input":"Input-module_input__WjT81","label":"Input-module_label__-OEBL","labelText":"Input-module_labelText__Bvv-T"};
styleInject(css_248z$5);

var TYPE_IDENTIFIER$1 = 'input/select';
var type$1 = function (settings) {
    return __assign(__assign({ nullable: true, multiple: false }, (settings || {})), { type: TYPE_IDENTIFIER$1 });
};
var Select = function (_a) {
    var label = _a.label, options = _a.options, value = _a.value, nullable = _a.nullable, onChange = _a.onChange, settings = __rest(_a, ["label", "options", "value", "nullable", "onChange"]);
    var values = options.map(function (option) {
        if (typeof option === 'string' || typeof option === 'number') {
            return {
                value: option,
                label: option,
            };
        }
        return option;
    });
    return (React__default.createElement("label", { className: inputStyles.label },
        React__default.createElement("span", { className: inputStyles.labelText }, label),
        React__default.createElement("select", __assign({ className: inputStyles.input }, settings, { value: value, onChange: function (e) {
                onChange(e.target.value);
            } }),
            nullable && React__default.createElement("option", { value: undefined }),
            values.map(function (o) { return (React__default.createElement("option", { key: o.value, value: o.value }, o.label)); }))));
};

var TYPE_IDENTIFIER = 'input/string';
var type = function (settings) {
    if (settings === void 0) { settings = {}; }
    return __assign(__assign({}, (settings || {})), { type: TYPE_IDENTIFIER });
};
var String = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, settings = _a.settings;
    return (React__default.createElement("label", { className: inputStyles.label },
        React__default.createElement("span", { className: inputStyles.labelText }, label),
        React__default.createElement("input", __assign({}, (settings || {}), { value: value, className: inputStyles.input, type: "text", onChange: function (e) { return onChange(e.target.value); } }))));
};

var index = { string: type, children: type$3, select: type$1, custom: type$2 };

var _a;
var DEFAULT_EDIT_MAP = (_a = {},
    _a[TYPE_IDENTIFIER] = {
        Component: String,
    },
    _a[TYPE_IDENTIFIER$1] = {
        Component: Select,
    },
    _a);

var validateConfig = function (config) {
    // check if the edit type exists.
    config.components.every(function (cc) {
        return Object.entries(cc.content).every(function (_a) {
            var k = _a[0], type = _a[1].type;
            if (config === null || config === void 0 ? void 0 : config.edit[type]) {
                //eslint-disable-next-line no-console
                console.log("%c\u2705 ".concat(cc.type, ":").concat(k, " validated as ").concat(type), 'color: darkgreen');
                return true;
            }
            //eslint-disable-next-line no-console
            console.log("%c\u274C edit type missing for ".concat(cc.type), 'color: red');
            return false;
        });
    });
};
var createNodeConfig = function (passedConfig) {
    return __assign({ icon: null, removable: true, editable: true }, passedConfig);
};
var createConfig = function (passedConfig) {
    var edit = __assign(__assign({}, DEFAULT_EDIT_MAP), (passedConfig.edit || {}));
    var config = __assign(__assign({}, passedConfig), { components: __spreadArray([], ((passedConfig === null || passedConfig === void 0 ? void 0 : passedConfig.components) || []), true).map(createNodeConfig), edit: edit });
    // validate the config before continuing
    validateConfig(config);
    return config;
};

var CMSContext = React__default.createContext({
    config: createConfig({}),
    tree: undefined,
    setTree: function () {
        // not initiated
    },
});
var useCMS = function () { return React__default.useContext(CMSContext); };

var EditContext = React__default.createContext({
    ref: null,
    editing: false,
    tree: { content: {}, type: 'unknown' },
    setEdit: function () {
        // not empty
    },
    append: function () {
        // not, empty
    },
    remove: function () {
        // not empty
    },
    patch: function () {
        // not empty
    },
    path: [],
    shift: function () {
        // not empty
    },
    move: function () {
        // not empty
    },
});
var useEdit = function () { return React__default.useContext(EditContext); };

var createEmpty = function (type, o) {
    return { content: o || {}, type: type };
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();

var root$1 = root;

/** Built-in value references. */
var Symbol = root$1.Symbol;

var Symbol$1 = Symbol;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$5.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$4.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray$1 = isArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];

var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var defineProperty$1 = defineProperty;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map = getNative(root$1, 'Map');

var Map$1 = Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var stringToPath$1 = stringToPath;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

/** clean the tree from faulty nodes */
var cleanTree = function (t) {
    var _a, _b;
    return Array.isArray((_a = t.content) === null || _a === void 0 ? void 0 : _a.children)
        ? __assign(__assign({}, t), { content: __assign(__assign({}, t.content), { children: (_b = t.content) === null || _b === void 0 ? void 0 : _b.children.filter(Boolean).map(cleanTree) }) }) : t;
};
function lossyDeepClone(o) {
    return JSON.parse(JSON.stringify(o));
}

var reducer = function (state, action) {
    switch (action.type) {
        case 'replace':
            return action.payload;
        case 'empty':
            return createEmpty('');
        case 'add': {
            var nstate = __assign({}, state);
            var parent_1 = get(nstate, action.path, []);
            set(nstate, action.path, __spreadArray(__spreadArray([], parent_1, true), [action.payload], false));
            return nstate;
        }
        case 'patch': {
            var nstate_1 = __assign({}, state);
            if (action.path.length > 0) {
                set(nstate_1, action.path, action.payload);
            }
            else {
                Object.entries(action.payload).forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    nstate_1[k] = v;
                });
            }
            return nstate_1;
        }
        case 'delete': {
            var nstate = __assign({}, state);
            unset(nstate, action.path);
            return cleanTree(nstate);
        }
        case 'move': {
            var nstate = __assign({}, state);
            if (!Array.isArray(action.from) || !Array.isArray(action.to)) {
                throw new Error('move action requires arrays');
            }
            var from = __spreadArray([], action.from, true);
            var to = __spreadArray([], action.to, true);
            // to and from become the path of their respective parent nodes
            var fromIndex = parseInt(from.pop());
            var toIndex = parseInt(to.pop());
            // `fromParent` and `toParent` should reference the same array
            // if the element is only moved within an array, otherwise the
            // element will be removed from the fromParent array, but the
            // change won't be reflected in the toParent array and thus not
            // in `nstate`.
            //
            // In other words, don't do this:
            // const fromParent = [...get(nstate, from)];
            // const toParent = [...get(nstate, to)];
            var fromParent = get(nstate, from);
            var toParent = get(nstate, to);
            var element = fromParent.splice(fromIndex, 1)[0];
            if (typeof element === 'undefined') {
                throw new Error("element doesn't exist");
            }
            toParent.splice(toIndex, 0, element);
            set(nstate, from, fromParent);
            set(nstate, to, toParent);
            return nstate;
        }
        default:
            throw new Error('Invalid action');
    }
};

/**
 *
 TODO
 * Add nice error messages for config faults
 */
var CMS = function (_a) {
    var _b = _a.tree, passedTree = _b === void 0 ? createEmpty('') : _b, passedConfig = _a.config, children = _a.children;
    var _c = React__default.useReducer(reducer, passedTree), tree = _c[0], setTree = _c[1];
    var _d = React__default.useState(passedConfig), config = _d[0], setConfig = _d[1];
    // keep tree in sync
    React__default.useEffect(
    // deep cloning the tree here ensures there's no issues with mutating the passed in object further down the tree.
    function () { return setTree({ type: 'replace', payload: lossyDeepClone(passedTree) }); }, [passedTree]);
    // keep config in sync
    React__default.useEffect(function () { return setConfig(passedConfig); }, [passedConfig]);
    return React__default.createElement(CMSContext.Provider, { value: { config: config, tree: tree, setTree: setTree } }, children);
};

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var cx = classnames.exports;

var _path$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21q-.825 0-1.412-.587Q5 19.825 5 19V6q-.425 0-.713-.287Q4 5.425 4 5t.287-.713Q4.575 4 5 4h4q0-.425.288-.713Q9.575 3 10 3h4q.425 0 .713.287Q15 3.575 15 4h4q.425 0 .712.287Q20 4.575 20 5t-.288.713Q19.425 6 19 6v13q0 .825-.587 1.413Q17.825 21 17 21zM7 6v13h10V6zm2 10q0 .425.288.712Q9.575 17 10 17t.713-.288Q11 16.425 11 16V9q0-.425-.287-.713Q10.425 8 10 8t-.712.287Q9 8.575 9 9zm4 0q0 .425.288.712.287.288.712.288t.713-.288Q15 16.425 15 16V9q0-.425-.287-.713Q14.425 8 14 8t-.712.287Q13 8.575 13 9zM7 6v13V6z"
  })));
}

var _path$4;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h1.4l8.625-8.625-1.4-1.4L5 17.6zM19.3 8.925l-4.25-4.2 1.4-1.4q.575-.575 1.413-.575.837 0 1.412.575l1.4 1.4q.575.575.6 1.388.025.812-.55 1.387zM4 21q-.425 0-.712-.288Q3 20.425 3 20v-2.825q0-.2.075-.387.075-.188.225-.338l10.3-10.3 4.25 4.25-10.3 10.3q-.15.15-.337.225-.188.075-.388.075zM14.325 9.675l-.7-.7 1.4 1.4z"
  })));
}

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 11.7q-.275-.275-.275-.7 0-.425.275-.7l4.6-4.6q.15-.15.325-.212.175-.063.375-.063t.375.063q.175.062.325.212l4.6 4.6q.275.275.287.687.013.413-.287.713-.275.275-.7.275-.425 0-.7-.275L12 7.825 8.1 11.7q-.275.275-.688.288Q7 12 6.7 11.7zm0 6q-.275-.275-.275-.7 0-.425.275-.7l4.6-4.6q.15-.15.325-.213.175-.062.375-.062t.375.062q.175.063.325.213l4.6 4.6q.275.275.287.687.013.413-.287.713-.275.275-.7.275-.425 0-.7-.275L12 13.825 8.1 17.7q-.275.275-.688.288Q7 18 6.7 17.7z"
  })));
}

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.575q-.2 0-.375-.063-.175-.062-.325-.212L6.7 7.7q-.275-.275-.287-.688Q6.4 6.6 6.7 6.3q.275-.275.7-.275.425 0 .7.275l3.9 3.875L15.9 6.3q.275-.275.687-.288Q17 6 17.3 6.3q.275.275.275.7 0 .425-.275.7l-4.6 4.6q-.15.15-.325.212-.175.063-.375.063zm0 6q-.2 0-.375-.063-.175-.062-.325-.212l-4.6-4.6q-.275-.275-.287-.688Q6.4 12.6 6.7 12.3q.275-.275.7-.275.425 0 .7.275l3.9 3.875 3.9-3.875q.275-.275.687-.288Q17 12 17.3 12.3q.275.275.275.7 0 .425-.275.7l-4.6 4.6q-.15.15-.325.212-.175.063-.375.063z"
  })));
}

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19q-.425 0-.712-.288Q11 18.425 11 18v-5H6q-.425 0-.713-.288Q5 12.425 5 12t.287-.713Q5.575 11 6 11h5V6q0-.425.288-.713Q11.575 5 12 5t.713.287Q13 5.575 13 6v5h5q.425 0 .712.287.288.288.288.713t-.288.712Q18.425 13 18 13h-5v5q0 .425-.287.712Q12.425 19 12 19z"
  })));
}

var css_248z$4 = ".Append-module_button__stT5C{background-color:rgba(0,0,0,.9);border:none;border-radius:100%;color:#fff;cursor:pointer;font-size:24px;height:40px;line-height:0;text-align:center;width:40px}.Append-module_button__stT5C svg{fill:currentColor}.Append-module_wrapper__Vokq9{display:flex;margin:10px}.Append-module_chooser__UM9Ma{display:flex;height:40px;width:auto}.Append-module_chooser__UM9Ma>*{margin-left:5px}.Append-module_chooser__UM9Ma button{background:rgba(0,0,0,.5);border:none;border-radius:4px;color:#fff;cursor:pointer;height:40px;padding:.5rem;width:40px}";
var styles$4 = {"button":"Append-module_button__stT5C","wrapper":"Append-module_wrapper__Vokq9","chooser":"Append-module_chooser__UM9Ma"};
styleInject(css_248z$4);

var filterChildren = function (children, config) {
    var _a;
    var childConfig = Object.values(config.content).find(function (t) { return t.type === 'input/children'; });
    var allowed = __spreadArray([], children, true);
    if (!childConfig) {
        return children;
    }
    if (((_a = childConfig.allowed) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        allowed = allowed.filter(function (c) { return childConfig.allowed.includes(c.type); });
    }
    if (childConfig.self === false) {
        allowed = allowed.filter(function (c) { return c.type !== config.type; });
    }
    return allowed;
};
var Append = function (_a) {
    var onClick = _a.onClick, config = _a.config;
    var _b = React__default.useState(false), open = _b[0], setOpen = _b[1];
    var ref = React__default.useRef(null);
    var CMSConfig = useCMS().config;
    var possibleChildren = filterChildren(CMSConfig.components, config);
    var handleClick = function (type) {
        setOpen(false);
        onClick(type);
    };
    return (React__default.createElement("div", { className: styles$4.wrapper },
        React__default.createElement("button", { className: styles$4.button, onClick: function () {
                return possibleChildren.length === 1 ? handleClick(possibleChildren[0].type) : setOpen(function (v) { return !v; });
            }, ref: ref },
            React__default.createElement(SvgAdd, null)),
        open && (React__default.createElement("div", { className: styles$4.chooser }, possibleChildren.map(function (s) { return (React__default.createElement("button", { onClick: function () { return handleClick(s.type); }, key: s.type }, s.icon || s.title.substring(0, 1))); })))));
};

var css_248z$3 = ".Button-module_root__Q2R8-{background:#000;border:none;border-radius:4px;box-sizing:border-box;color:#fff;cursor:pointer;margin-top:auto;padding:.5rem 2rem}";
var styles$3 = {"root":"Button-module_root__Q2R8-"};
styleInject(css_248z$3);

var Button = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React__default.createElement("button", __assign({ type: 'button' }, props, { className: cx(styles$3.root, className) }), children));
};

var css_248z$2 = ".Modal-module_backdrop__GVUh4{background-color:hsla(0,0%,100%,.85);bottom:0;left:0;position:fixed;right:0;top:0;z-index:2999}.Modal-module_root__ytPLl{background:#fff;border-radius:24px;box-shadow:0 50px 100px -20px rgba(50,50,93,.25),0 30px 60px -30px rgba(0,0,0,.3);left:50%;min-height:500px;padding:24px;position:absolute;top:50%;transform:translate(-50%,-50%);width:400px;z-index:3000}";
var styles$2 = {"backdrop":"Modal-module_backdrop__GVUh4","root":"Modal-module_root__ytPLl"};
styleInject(css_248z$2);

var Modal = function (_a) {
    var children = _a.children, onClose = _a.onClose, className = _a.className, props = __rest(_a, ["children", "onClose", "className"]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("style", null, "body{overflow: \"hidden\";}"),
        React__default.createElement("div", { className: styles$2.backdrop, onClick: function () {
                onClose && onClose();
            } },
            React__default.createElement("div", __assign({ className: cx(styles$2.root, className) }, props, { onClick: function (e) { return e.stopPropagation(); } }), children))));
};

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4l-4.9 4.9q-.275.275-.7.275-.425 0-.7-.275-.275-.275-.275-.7 0-.425.275-.7l4.9-4.9-4.9-4.9q-.275-.275-.275-.7 0-.425.275-.7.275-.275.7-.275.425 0 .7.275l4.9 4.9 4.9-4.9q.275-.275.7-.275.425 0 .7.275.275.275.275.7 0 .425-.275.7L13.4 12l4.9 4.9q.275.275.275.7 0 .425-.275.7-.275.275-.7.275-.425 0-.7-.275z"
  })));
}

var css_248z$1 = ".EditGroup-module_separate__Cic9G{display:block}.EditGroup-module_separate__Cic9G>*+*{margin-top:1rem}.EditGroup-module_title__4VchS{margin:0}.EditGroup-module_close__UWp29{border-radius:0;bottom:0;left:0;position:absolute;width:100%}";
var styles$1 = {"separate":"EditGroup-module_separate__Cic9G","title":"EditGroup-module_title__4VchS","close":"EditGroup-module_close__UWp29"};
styleInject(css_248z$1);

var EditGroup = function (_a) {
    var content = _a.content;
    var config = useCMS().config;
    var _b = useEdit(), patch = _b.patch, editing = _b.editing, tree = _b.tree, setEdit = _b.setEdit;
    var c = config.components.find(function (t) { return t.type === tree.type; });
    var handleChange = function (k) { return function (v) {
        var _a;
        patch(__assign(__assign({}, ((tree === null || tree === void 0 ? void 0 : tree.content) || {})), (_a = {}, _a[k] = v, _a)));
    }; };
    return editing ? (React__default.createElement(Modal, { onClose: function () { return setEdit(false); } },
        React__default.createElement("div", { className: styles$1.separate },
            React__default.createElement("h2", { className: styles$1.title }, (c === null || c === void 0 ? void 0 : c.title) || ''),
            React__default.createElement("p", null, (c === null || c === void 0 ? void 0 : c.description) || ''),
            Object.entries(content).map(function (_a) {
                var k = _a[0], editConfig = _a[1];
                // for now; opt out of displaying children as a prop here.
                if (k === 'children') {
                    return null;
                }
                var type = editConfig.type, editProps = __rest(editConfig, ["type"]);
                var Component = config.edit[type].Component;
                return (React__default.createElement("section", { className: styles$1.layout, key: k },
                    React__default.createElement(Component, __assign({ label: k, value: (tree === null || tree === void 0 ? void 0 : tree.content[k]) || undefined }, editProps, { onChange: handleChange(k) }))));
            }),
            React__default.createElement(Button, { onClick: function () { return setEdit(false); }, className: styles$1.close },
                React__default.createElement(SvgClose, { width: "24px", fill: "currentColor" }))))) : null;
};

var css_248z = ".Editable-module_root__KRZ-w{display:flow-root;position:relative;transition:box-shadow .1s}.Editable-module_toolbar__98RFE{align-items:center;background:rgba(0,0,0,.7);border-radius:.25rem;display:flex;left:0;padding:.25rem;position:absolute;top:0;z-index:99999}.Editable-module_toolbar__98RFE button{background-color:transparent;border:none;color:#a9a9a9;cursor:pointer}.Editable-module_toolbar__98RFE button:hover{color:#fff}.Editable-module_clickable__Qqq2B{cursor:pointer}";
var styles = {"root":"Editable-module_root__KRZ-w","toolbar":"Editable-module_toolbar__98RFE","clickable":"Editable-module_clickable__Qqq2B"};
styleInject(css_248z);

/**
 * Editable, wraps the child component with some tooling for talking to the admin.
 *
 * @param config a Config for a single Component.
 * @returns a rendered component
 */
var Editable = function (_a) {
    var _b;
    var tree = _a.tree, config = _a.config, children = _a.children, _c = _a.path, path = _c === void 0 ? [] : _c;
    // A ref to the parent. Could potentially be used to pin something or measure it to allow content-jumping.
    var ref = React__default.useRef(null);
    // DERIVED
    var Component = config.Component, _d = config.content, content = _d === void 0 ? {} : _d;
    var isomorphic = content.isomorphic;
    var childrenConfig = Object.values(content).find(function (c) { return c.type === 'input/children'; }); // todo: Use a nice way to find all active child-like input types
    // CONTEXTS
    var setTree = useCMS().setTree;
    // STATES
    var _e = React__default.useState(false), editing = _e[0], setEdit = _e[1];
    var _f = React__default.useState(false), over = _f[0], setOver = _f[1];
    var append = React__default.useCallback(function (type, o) {
        setTree({
            payload: createEmpty(type, o),
            type: 'add',
            path: __spreadArray(__spreadArray([], path, true), ['content', 'children'], false),
        });
    }, [path, setTree]);
    var patch = React__default.useCallback(function (_content) {
        setTree({
            payload: __assign(__assign({}, tree), { content: _content }),
            path: path,
            type: 'patch',
        });
    }, [path, tree, setTree]);
    var shift = React__default.useCallback(function (steps) {
        var dest = __spreadArray([], path, true);
        var i = parseInt(dest[dest.length - 1]) + steps;
        if (isNaN(i))
            return;
        dest[dest.length - 1] = i.toString();
        move(dest);
    }, [path, tree, setTree]);
    var move = React__default.useCallback(function (to) {
        setTree({
            from: path,
            to: to,
            type: 'move',
        });
    }, [path, tree, setTree]);
    var remove = React__default.useCallback(function () { return setTree({ type: 'delete', path: path }); }, [path, setTree]);
    var toggleOpen = function (bool) {
        setOver(bool);
    };
    var componentProps = __assign(__assign({}, ((tree === null || tree === void 0 ? void 0 : tree.content) || {})), (childrenConfig
        ? {
            children: (React__default.createElement(React__default.Fragment, null,
                children,
                childrenConfig.append && React__default.createElement(Append, { onClick: append, config: config }))),
        }
        : {}));
    return (React__default.createElement(EditContext.Provider, { value: { editing: editing, tree: tree, setEdit: setEdit, patch: patch, remove: remove, path: path, ref: ref, append: append, shift: shift, move: move } },
        React__default.createElement("div", { "data-path": path.join(".") }, isomorphic ? (React__default.createElement(Component, __assign({ onChange: patch }, componentProps))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("span", { ref: ref, onClick: config.editOnClick ? function () { return setEdit(true); } : undefined, className: cx(styles.root, (_b = {}, _b[styles.clickable] = config.editOnClick, _b)), onMouseEnter: function (e) {
                    e.stopPropagation();
                    toggleOpen(true);
                }, onMouseLeave: function (e) {
                    e.stopPropagation();
                    toggleOpen(false);
                } },
                React__default.createElement(Component, __assign({}, componentProps)),
                Boolean(over && (config.removable || config.editable || config.movable)) && (React__default.createElement("span", { className: styles.toolbar },
                    config.editable && (React__default.createElement("button", { onClick: function (e) {
                            e.stopPropagation();
                            setEdit(function (v) { return !v; });
                        } },
                        React__default.createElement(SvgEdit, { fill: "currentColor" }))),
                    config.removable && (React__default.createElement("button", { onClick: function (e) {
                            e.stopPropagation();
                            remove();
                        } },
                        React__default.createElement(SvgDelete, { fill: "currentColor" }))),
                    config.movable && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("button", { onClick: function (e) {
                                e.stopPropagation();
                                shift(-1);
                            } },
                            React__default.createElement(SvgUp, { fill: "currentColor" })),
                        React__default.createElement("button", { onClick: function (e) {
                                e.stopPropagation();
                                shift(1);
                            } },
                            React__default.createElement(SvgDown, { fill: "currentColor" }))))))),
            editing && React__default.createElement(EditGroup, { content: content }))))));
};

/**
 *
 * @param config Config to use for resolving the components to be rendered
 * @param tree a NodeTree to be walked
 * @param edit boolean - if true wraps the target component in an Edit-component.
 * @returns a rendered tree of components
 */
var EditorTree = function (_a) {
    var tree = _a.tree, _b = _a.path, path = _b === void 0 ? [] : _b;
    var config = useCMS().config;
    var components = config.components;
    // find the config for this component
    var Config = components.find(function (c) { return c.type === tree.type; });
    if (!Config) {
        return null;
    }
    var children = tree.content.children;
    return (React__default.createElement(Editable, { config: Config, tree: tree, path: path }, Array.isArray(children) &&
        (children === null || children === void 0 ? void 0 : children.map(function (child, i) {
            var k = __spreadArray(__spreadArray([], path, true), ['content', 'children', i.toString()], false);
            return React__default.createElement(EditorTree, { tree: child, key: k.join('.'), path: k });
        }))));
    // This tree has no children. Render as is.
    // return <Editable config={Config} data={item.content} key={index} path={path} index={index} />;
};

// import { createPortal } from 'react-dom';
/**
 * TODO;
 * isolating with iframes tend to isolate too much, styles are hard to pass down and other problems arise.
 * For now this component is purely structural and does not actually isolate anything.
 */
var IsolateStyles = function (_a) {
    // const contentRef = React.useRef<HTMLIFrameElement>(null);
    var children = _a.children, props = __rest(_a, ["children"]);
    // const mountNode = contentRef?.current?.contentWindow?.document?.body as HTMLElement;
    // const [ready, setReady] = React.useState(false);
    // React.useEffect(() => {
    //   console.log('second render', mountNode, contentRef);
    //   setReady(true);
    // }, []);
    // return (
    //   <iframe {...props} ref={contentRef} frameBorder="0">
    //     {Boolean(ready && mountNode) && createPortal(children, mountNode)}
    //   </iframe>
    // );
    return React__default.createElement("div", __assign({}, props), children);
};

var Preview = function () {
    var tree = useCMS().tree;
    return React__default.createElement(IsolateStyles, null, tree && React__default.createElement(EditorTree, { tree: tree }));
};

var Renderer = function (_a) {
    var config = _a.config, tree = _a.tree;
    if (tree === undefined) {
        return null;
    }
    var components = config.components;
    // find the config for this component
    var Config = components.find(function (c) { return c.type === tree.type; });
    // No type found. This is not a component.
    if (!Config) {
        return null;
    }
    var _b = tree.content, children = _b.children, props = __rest(_b, ["children"]);
    return (React__default.createElement(Config.Component, __assign({}, props, { "data-uri": tree.uri }), Array.isArray(children)
        ? children.map(function (t, i) { return (React__default.createElement(Renderer, { key: i, tree: t, config: config })); })
        : children));
};

export { CMS, CMSContext, index as CMSType, Preview, Renderer, createConfig, createEmpty, useCMS, useEdit, validateConfig };
//# sourceMappingURL=index.esm.js.map
